import React from 'react';

const MUI_CHECKBOX_CLASS = 'MuiTypography-root';
const MUI_LABEL_CLASS = 'MuiFormControlLabel-root';

export const isMuiCheckboxClick = (
	e: React.MouseEvent<HTMLLIElement, MouseEvent>,
) => {
	const targetClasses = (e.target as HTMLElement).classList;
	return (
		targetClasses.contains(MUI_CHECKBOX_CLASS) ||
		targetClasses.contains(MUI_LABEL_CLASS)
	);
};
